import React, { useState } from 'react';

const toNumber = (raw, fallback = 0) => {
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : fallback;
  if (raw === null || raw === undefined) return fallback;
  const cleaned = `${raw}`.replace(/[$,%\s]/g, '').replace(/,/g, '');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : fallback;
};

export default function AccountsManager({ accounts, setAccounts, trades, userId, supabase, C, cardStyle, inp }) {
  const [form,setForm]=useState({name:'',broker:'',type:'Live',balance:''});
  const add=async()=>{
    if(!form.name)return;
    const newAcc={...form,user_id:userId};
    const {data,error}=await supabase.from('accounts').insert([newAcc]).select().single();
    if(!error&&data) setAccounts(prev=>[...prev,data]);
    setForm({name:'',broker:'',type:'Live',balance:''});
  };
  const remove=async(id)=>{
    await supabase.from('accounts').delete().eq('id',id);
    setAccounts(prev=>prev.filter(a=>a.id!==id));
  };
  const typeColors={Live:C.greenBright,Paper:C.blue,Crypto:C.orange,Forex:C.purple};
  return (
    <div>
      <div style={{...cardStyle,padding:'22px',marginBottom:'16px'}}>
        <h3 style={{margin:'0 0 16px',fontSize:'15px',fontWeight:'700',color:C.text}}>🏦 Add Account</h3>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:'10px',marginBottom:'12px'}}>
          {[['name','Name','My Main'],['broker','Broker','IBKR...'],['balance','Balance ($)','10000']].map(([k,l,p])=>(
            <div key={k}><div style={{color:C.sub,fontSize:'10px',marginBottom:'5px',fontWeight:'600',textTransform:'uppercase'}}>{l}</div><input value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} placeholder={p} style={inp}/></div>
          ))}
          <div><div style={{color:C.sub,fontSize:'10px',marginBottom:'5px',fontWeight:'600',textTransform:'uppercase'}}>Type</div><select value={form.type} onChange={e=>setForm({...form,type:e.target.value})} style={inp}><option>Live</option><option>Paper</option><option>Crypto</option><option>Forex</option></select></div>
        </div>
        <button onClick={add} style={{padding:'9px 20px',background:C.blue,color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'700',fontSize:'13px'}}>+ Add Account</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))',gap:'12px'}}>
        {accounts.map(acc=>{
          const accTrades=trades.filter(t=>t.account===acc.name);
          const pnl=accTrades.reduce((s,t)=>s + toNumber(t.pnl),0);
          const brokerLabel = (acc.broker && acc.broker.trim())
            ? acc.broker
            : acc.name === 'Main Account'
              ? 'IBKR'
              : 'No broker';
          return (
            <div key={acc.id} style={{...cardStyle,padding:'18px',borderTop:`2px solid ${typeColors[acc.type]||C.blue}`}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                <div style={{fontWeight:'700',color:C.text}}>{acc.name}</div>
                <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                  <span style={{background:`${typeColors[acc.type]}22`,color:typeColors[acc.type],padding:'2px 8px',borderRadius:'20px',fontSize:'10px',fontWeight:'700'}}>{acc.type}</span>
                  {accounts.length>1&&<button onClick={()=>remove(acc.id)} style={{background:'none',border:'none',cursor:'pointer',color:C.sub,fontSize:'12px'}}>🗑️</button>}
                </div>
              </div>
              <div style={{color:C.sub,fontSize:'11px',marginBottom:'10px'}}>🏛️ {brokerLabel}</div>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <div><div style={{color:C.sub,fontSize:'10px'}}>P&L</div><div style={{color:pnl>=0?C.greenBright:C.redBright,fontSize:'18px',fontWeight:'800'}}>${pnl.toFixed(2)}</div></div>
                <div><div style={{color:C.sub,fontSize:'10px'}}>Trades</div><div style={{color:C.text,fontSize:'18px',fontWeight:'800'}}>{accTrades.length}</div></div>
                {acc.balance&&<div><div style={{color:C.sub,fontSize:'10px'}}>Balance</div><div style={{color:C.text,fontSize:'18px',fontWeight:'800'}}>${(toNumber(acc.balance)+pnl).toFixed(0)}</div></div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
